import { render, staticRenderFns } from "./EnterCelestialsModal.vue?vue&type=template&id=53ece7ca&scoped=true"
import script from "./EnterCelestialsModal.vue?vue&type=script&lang=js"
export * from "./EnterCelestialsModal.vue?vue&type=script&lang=js"
import style0 from "./EnterCelestialsModal.vue?vue&type=style&index=0&id=53ece7ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ece7ca",
  null
  
)

export default component.exports